import { c as _c } from "react/compiler-runtime";
import profileImage from "@/assets/png/profile.png";
import Image from "next/image";
import { HTMLAttributes } from "react";
type ProfileImageSize = "sm" | "md" | "lg";
export interface ProfileImageProps extends HTMLAttributes<HTMLDivElement> {
  size?: ProfileImageSize;
  priority?: boolean;
  showBorder?: boolean;
}
const sizeClasses = {
  sm: "w-48 h-48 lg:w-56 lg:h-56",
  md: "w-64 h-64 md:w-80 md:h-80",
  lg: "w-80 h-80 md:w-96 md:h-96"
};
const sizeSizes = {
  sm: "(max-width: 48rem) 12rem, 14rem",
  md: "(max-width: 48rem) 16rem, 20rem",
  lg: "(max-width: 48rem) 20rem, 24rem"
};
export const ProfileImage = t0 => {
  const $ = _c(17);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      priority: t2,
      showBorder: t3,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? "md" : t1;
  const priority = t2 === undefined ? false : t2;
  const showBorder = t3 === undefined ? true : t3;
  const t4 = `relative ${sizeClasses[size]} shrink-0 ${className || ""}`;
  const t5 = sizeSizes[size];
  const t6 = priority ? "eager" : undefined;
  let t7;
  if ($[6] !== priority || $[7] !== t5 || $[8] !== t6) {
    t7 = <div className="absolute inset-0 rounded-3xl overflow-hidden"><Image src={profileImage} alt="Profile picture" fill={true} sizes={t5} className="object-cover object-[center_top] scale-110" priority={priority} loading={t6} /></div>;
    $[6] = priority;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== showBorder) {
    t8 = showBorder && <div className="absolute inset-0 rounded-3xl pointer-events-none border-2 border-white/60 glow" />;
    $[10] = showBorder;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== props || $[13] !== t4 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className={t4} {...props}>{t7}{t8}</div>;
    $[12] = props;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};